var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._g(_vm._b({staticClass:"main-container height rounded",class:[this.large ? 'large' : '']},'div',_vm.$attrs,false),_vm.$listeners),[_c('div',{staticClass:"progress height rounded",style:({ width: _vm.width })})])}
var staticRenderFns = []

export { render, staticRenderFns }